import React, { FC, useEffect, ReactElement, useContext, useRef } from 'react';
import { PrefferencesContext } from '../../context/context';
import Dropdown from '../dropdown/dropdown';
import Matches from '../matches/matches';
import Teaser from '../teaser/teaser';
import { getLanguageOption, getTenantFromHost, getTeaser } from '../../helpers/helperFunctions';

const MainPage: FC = (): ReactElement => {
  const { theme, setTheme, setLanguage, parentHost, setParentHost, setWidgetWidth } = useContext(
    PrefferencesContext
  );

  const mainPageRef = useRef<HTMLDivElement>(null);

  // Determine widget width
  useEffect(() => {
    const widthListener = () => {
      if (mainPageRef.current) {
        const width = mainPageRef.current.scrollWidth;
        setWidgetWidth(width);
      }
    };
    widthListener();
    window.addEventListener('resize', widthListener);
    return () => window.removeEventListener('resize', widthListener);
  }, []);

  // Determine host of parent window (to set up appropriate fonts)
  useEffect(() => {
    try {
      setParentHost(getTenantFromHost());
    } catch (e) {
      console.log('Error processing parent host');
    }
  }, []);

  // Determine language queryString option
  useEffect(() => {
    try {
      setLanguage(getLanguageOption());
    } catch (e) {
      console.log('Error processing language option');
    }
  }, []);

  window.addEventListener('message', (event) => {
    // this check is needed because of https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#security_concerns
    if (event.data.type === 'colorMode') {
      // assuming you have a function setColorModeInChildApp in your app
      setTheme(event.data.mode); // will be the string 'dark' or 'light'
    }
  });

  return (
    <div className={`_${parentHost} main-page main-page-${theme}`} ref={mainPageRef}>
      {!getTeaser() && <Dropdown />}
      <div className={`table-results-wrapper ${getTeaser() ? 'table-results-wrapper-teaser' : ''}`}>
        <div className="flex1" />
        <div className="table">{getTeaser() ? <Teaser /> : <Matches />}</div>
        <div className="flex1" />
      </div>
    </div>
  );
};

export default MainPage;
